"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.briefcase = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const briefcase = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'briefcase-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12 2.25C12.9665 2.25 13.75 3.0335 13.75 4V5.25H17C17.9665 5.25 18.75 6.0335 18.75 7V16C18.75 16.9665 17.9665 17.75 17 17.75H3C2.0335 17.75 1.25 16.9665 1.25 16V7C1.25 6.0335 2.0335 5.25 3 5.25H6.25V4C6.25 3.0335 7.0335 2.25 8 2.25H12ZM3 6.75C2.86193 6.75 2.75 6.86193 2.75 7V7.5613L10 11.6394L17.25 7.5613V7C17.25 6.86193 17.1381 6.75 17 6.75H3ZM12.25 5.25H7.75V4C7.75 3.86193 7.86193 3.75 8 3.75H12C12.1381 3.75 12.25 3.86193 12.25 4V5.25ZM2.75 9.28232L9.61509 13.1439C9.65449 13.1674 9.69586 13.1872 9.73861 13.2031C9.82388 13.2349 9.91237 13.2502 10 13.2501C10.1354 13.25 10.2687 13.2132 10.3849 13.1439L17.25 9.28232V16C17.25 16.1381 17.1381 16.25 17 16.25H3C2.86193 16.25 2.75 16.1381 2.75 16V9.28232Z', fill: '#4B5563' })));
};
exports.briefcase = briefcase;
